import { useSubscriptionContext } from '@/context'
import { UsageRecord } from '@/types/user'
import { UsageRecordModule, canUseModule } from '@/utils/access'
import { StringParam, useQueryParam } from 'use-query-params'

const useModuleAccess = ({
    module,
}: {
    module: UsageRecordModule
}): {
    canAccess: boolean
    usage_record: UsageRecord
    setUpgrade: (value: string) => void
} => {
    const { usage_record } = useSubscriptionContext()
    const [_, setUpgrade] = useQueryParam('upgrade', StringParam)

    if (!usage_record) {
        return {
            canAccess: false,
            usage_record: {
                user: '',
                workspace: {
                    allowed: 0,
                    used: 0,
                },
                brand_voice: {
                    allowed: 0,
                    used: 0,
                },
                structure: {
                    allowed: 0,
                    used: 0,
                },
                action: {
                    allowed: 0,
                    used: 0,
                },
            },
            setUpgrade: () => {
                return
            },
        }
    }

    const canAccess = canUseModule(usage_record, module)

    return {
        canAccess,
        usage_record,
        setUpgrade,
    }
}

export default useModuleAccess
